import s from "./styles.module.sass";

const GeneralDirector = () => {
	return (
		<section className={`${s.genetarDirectorBlock} marginedSection`}>
			<div className={s.generalDirectorImage} />
			<div className={s.quoteBlock}>
				<p className={s.quote}>
					Авторы могут <b>сами создавать</b> контент или воспользоваться помощью наших редакторов и
					продюсеров. <b>Мы поможем</b> грамотно оформить и<b>&nbsp; продать ваши знания.</b>
				</p>
				<p className={s.author}>— Ольга Каспржак, Генеральный&nbsp;директор&nbsp;Selfschool</p>
			</div>
		</section>
	);
};

export default GeneralDirector;
